'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MenuTriggerContextProvider: function() {
        return MenuTriggerContextProvider;
    },
    useMenuTriggerContext_unstable: function() {
        return useMenuTriggerContext_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
/**
 * Context used communicate with a child menu item that it is a trigger for a submenu
 */ const MenuTriggerContext = /*#__PURE__*/ _react.createContext(undefined);
const menuTriggerContextDefaultValue = false;
const MenuTriggerContextProvider = MenuTriggerContext.Provider;
const useMenuTriggerContext_unstable = ()=>{
    var _React_useContext;
    return (_React_useContext = _react.useContext(MenuTriggerContext)) !== null && _React_useContext !== void 0 ? _React_useContext : menuTriggerContextDefaultValue;
};
